module.exports = __webpack_public_path__ + "img/it.candy.simplyfi.66967fe9.webp";